module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-144x144.png";